import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth/auth-service';
@Injectable()
export class AdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private _router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    {
    let config: any;
    if (localStorage.getItem('app_token') != null) {
      config = JSON.parse(localStorage.getItem('app_token'));
      return config.isAdmin ? true : false;
    }
    }
  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/auth-guard-service.ts